import { useState, useEffect } from "react";

import firebase from "./firebase";
import { isDev, getPartnerName, isLocalHost, isDeveloperDev } from "../helpers";
import mockPartnerInfo from "../mock/taumi.json";

const PARTNER_COLLECTION = getPartnerName().toLowerCase();

const db = firebase.firestore();

export const useStatisticVariables = () => {
  const [statisticVariables, setStatisticVariables] = useState({});

  useEffect(() => {
    if (isDev) console.log("fetch statisticVariables");
    const unsubscribe = db
      .collection(PARTNER_COLLECTION)
      .onSnapshot((snapshot) =>
        // snapshot.forEach((doc) =>
        // setStatisticVariables((pre) => ({ ...pre, [doc.id]: doc.data() }))
        // )
        {
          setStatisticVariables(
            Object.fromEntries(snapshot.docs.map((doc) => [doc.id, doc.data()]))
          );
        }
      );
    return () => {
      unsubscribe();
    };
  }, [db, PARTNER_COLLECTION, setStatisticVariables]);
  return statisticVariables;
};

export const useOrder = (orderID) => {
  const [orderLoaded, setOrderLoaded] = useState(false);
  const [orderInfo, setOrderInfo] = useState({ order: [], contactInfo: {} });
  useEffect(() => {
    if (isDev) console.log("fetch order ", orderID);
    const unsubscribe = db
      .collection(isDeveloperDev ? "devOrders" : "orders")
      .doc(orderID)
      .onSnapshot((snapshot) => {
        if (snapshot.exists) setOrderInfo(snapshot.data());
        setOrderLoaded(true);
      });
    return () => {
      unsubscribe();
    };
  }, [orderID]);
  return { orderInfo, orderLoaded };
};

export const addOrder = async ({ content }) => {
  return db
    .collection(isDeveloperDev ? "devOrders" : "orders")
    .add({
      ...content,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      partnerName: getPartnerName().toLowerCase(),
      version: "v2",
      paid: false,
      isDev: isDev,
    })
    .then((docRef) => {
      console.log("Document written with ID: ", docRef.id);
      return docRef.id;
    })
    .catch((error) => console.error("Error adding document: ", error));
};

export const setUserWithId = async ({ id, content }) => {
  const collection = isDeveloperDev ? "devUsers" : "users";
  return db
    .collection(collection)
    .doc(id)
    .set(
      {
        ...content,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        partnerName: getPartnerName().toLowerCase(),
        version: "v2",
      },
      { merge: true }
    )
    .then(() => {
      if (isDev)
        console.log("Document successfully written in ", collection, id);
    })
    .catch((error) => console.log("Error writting document: ", error));
};

export const updateDataWithId = async ({ collection, id, content }) => {
  return db
    .collection(collection)
    .doc(id)
    .update({
      ...content,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    })
    .then(() => {
      if (isDev) console.log(collection, id, "successully uptated");
    })
    .catch((error) => console.log("Error in updating ", collection, id, error));
};
